import React, { useState } from 'react'

import { firestore } from '../../../../../firebase';

function UpdateGeneratedTeams({id, roundId, teamDraw, requestCount, setRequestCount, draw, playersDraw, updateCount, setUpdateCount}) {

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    async function updateHandler(e) {
        e.preventDefault();
        try {
            const teamsRoundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("teams").doc(teamDraw.id);
            if (!draw || !playersDraw) {
                setError("Trekning eller spillere ikke definert");
                return
            }
            const data = {
                teams: playersDraw,
                draw: draw
            }
            console.log(data)
            teamsRoundRef.update(data);
            setMessage("Lag oppdatert!")
            setUpdateCount(updateCount+1)
            setRequestCount(requestCount+1)
        } catch (error) {
            setError("Kunne ikke oppdatere lag")
            console.log(error)
        }
    }

    return (
        <form onSubmit={updateHandler}>
            <button className="btn btn-success btn-block">Oppdater lag</button>
        </form>
    )

}
export default UpdateGeneratedTeams